// Fetch country code from browsing_context_suggestions.json
async function getCountryCode() {

	let cachedCountryCode = sessionStorage.getItem('COUNTRY_CODE');

	// Debug
	console.log("You are visiting from: " + cachedCountryCode)

	if (cachedCountryCode) {
		return cachedCountryCode;
	}

	try {
		const response = await fetch('/browsing_context_suggestions.json');
		const data = await response.json();
		countryCode = data?.detected_values?.country?.handle || 'UNKNOWN';

		// Save in storage
		sessionStorage.setItem('COUNTRY_CODE', countryCode);
		return countryCode;
	} catch (error) {
		console.error('Error fetching browsing context:', error);
		countryCode = 'UNKNOWN';
		return countryCode;
	}
}

function shippingThreshold(cartData = null, el) {
	// Determine threshold based on country
	const getThreshold = async () => {
		const countryCode = await getCountryCode();
		if (countryCode === el.dataset.countryCode) {
			return el.dataset.domThreshold || 14000; // $140 in cents for AU/US
		} else {
			return el.dataset.intThreshold || 25000; // $250 in cents for other countries
		}
	};

	// Use Promise to handle async threshold
	getThreshold().then(threshold => {
		const progressBar = el.querySelector('.progress-bar__fill');
		const amountText = el.querySelector('.amount-left');
		const msgFilled = el.querySelector('.msg--filled');
		const msgFilling = el.querySelector('.msg--filling');

		if (!progressBar || !amountText) {
			console.warn('Free shipping progress elements not found');
			return;
		}

		const updateUI = (subtotal) => {
			const percentage = Math.min((subtotal / threshold) * 100, 100);
			const amountLeft = ((threshold - subtotal) / 100).toFixed(2);
			progressBar.style.width = `${percentage}%`;

			if (subtotal >= threshold) {
				msgFilled.style.display = 'block';
			} else {
				amountText.textContent = `$${amountLeft}`;
				msgFilling.style.display = 'block';
			}
		};

		if (cartData && cartData.total_price) {
			updateUI(cartData.total_price);
		} else {
			fetch('/cart.js')
				.then(response => response.json())
				.then(cart => updateUI(cart.total_price))
				.catch(error => console.error('Error fetching cart:', error));
		}
	});
}

class FreeShippingProgress extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		// Hide if visitor is NOT from allowed country
		getCountryCode().then(country => {
			const allowed = this.dataset.countryCode; // e.g. "US", "AU" etc.

			if (country !== allowed) {
			this.classList.add('hidden');
			}
		});
		shippingThreshold(null, this);
		this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			shippingThreshold(event.cart, this);
		});
	}

	disconnectedCallback() {
		if (this.unsubscribe) {
			this.unsubscribe();
		}
	}
}

customElements.define('free-shipping-progress', FreeShippingProgress);